import {
  CONFIGURATION_ITEM_FRAGMENT,
  INTERNAL_CONFIGURATION_ITEM_FRAGMENT,
} from "@gql/fragments/configuration/configurationItemFragment";
import gql from "graphql-tag";

export const CONFIGURATION_ITEM_QUERY = gql`
  query ConfigurationItem($id: uuid!, $user_id: String!) {
    product_cloud_configuration_item(where: { user_id: { _eq: $user_id }, id: { _eq: $id } }) {
      ...configurationItemFields
    }
  }
  ${CONFIGURATION_ITEM_FRAGMENT}
`;

export const INTERNAL_CONFIGURATION_ITEM_QUERY = gql`
  query InternalConfigurationItem($id: uuid!) {
    product_cloud_configuration_item(where: { id: { _eq: $id } }) {
      ...internalConfigurationItemFields
    }
  }
  ${INTERNAL_CONFIGURATION_ITEM_FRAGMENT}
`;
